module.exports = __webpack_public_path__ + "img/plus-circle.b745d02a.svg";